<!-- 导入添加费用 -->
<template>
  <div class="flex-c">
    <el-button
      icon="el-icon-download"
      size="small"
      style="margin: 0 10px 10px 0"
      @click="Download"
    >{{ $t('receivablePayable.DownloadTheTemplate') }}</el-button>
    <upload-excel
      :on-success="importLogistics"
      :before-upload="beforeUpload"
      :but-name="$t('receivablePayable.ImportAddCharges')"
    />
  </div>
</template>

<script>
import { isValidDateTime } from '@/views/finance/payableManage/feesPayable/utils';

const ExcelJS = require('exceljs');
import { saveAs } from 'file-saver';
import uploadExcel from '@/components/UploadExcel';
import {
  apiPayableSiteExpenseImportAddFee,
  apiPayableTransportExpenseDownloadImportAddFee
} from '@/api/finance/receivables';
import { goFileUploadManagement } from '@/utils/goExportList.js';
import i18n from '@/lang';

const MAX_LENGTH = 100000;
// 1安骏小屋，2第三方揽收，3AJD派送, 4DSP派送, 5运输干支线 6 邮局派送
const titleMap = {
  1: i18n.t('receivablePayable.AnjunCottage'), // 安俊
  2: i18n.t('receivablePayable.ThirdPartyCollection'), // 第三方
  3: i18n.t('receivablePayable.AJDDispatch'), // AJD
  4: i18n.t('receivablePayable.DSPDispatch'), // DSP
  5: i18n.t('receivablePayable.Transportation_trunk_branch'), // 干支线
  6: i18n.t('receivablePayable.postOfficeDelivery'), // 邮局派送
  7: i18n.t('receivablePayable.MDDDispatch') // MDD
};

export default {
  name: 'ImportAddFees',

  components: {
    uploadExcel
  },
  props: {
    // 账单类型
    payableType: {
      type: Number,
      required: true
    },

    // 费用类型
    feeTypeList: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      fileName: ''
    };
  },

  methods: {
    Download() {
      if ([1, 2].includes(this.payableType)) {
        this.downloadTemplate_one();
      } else if (this.payableType === 5) {
        this.downloadTemplate_three();
      } else {
        this.downloadTemplate_two();
      }
    },
    // 下载模板(揽收和小屋)
    async downloadTemplate_one() {
      const that = this;
      async function ddd() {
        const wb = new ExcelJS.Workbook();
        const Sheet1 = wb.addWorksheet('Sheet1');
        const Sheet2 = wb.addWorksheet('Sheet2');
        const Sheet3 = wb.addWorksheet('Sheet3');
        const Sheet4 = wb.addWorksheet('Sheet4');
        const Sheet5 = wb.addWorksheet('Sheet5');
        Sheet1.columns = [
          {
            header: '是否存在数据',
            key: 'exitData',
            width: 40
          },
          {
            header: '业务单号',
            key: 'waybillNumber',
            width: 40
          },
          {
            header: '揽收类型',
            key: 'collectType',
            width: 40
          },
          {
            header: '费用类型',
            key: 'feeCode',
            width: 40
          },
          {
            header: '应付金额',
            key: 'fee',
            width: 40
          },
          {
            header: '业务时间(格式：2022-01-01 00:00:00)',
            key: 'operateTime',
            width: 80
          },
          {
            header: '平摊方式',
            key: 'flatMethod',
            width: 40
          },
          {
            header: '备注',
            key: 'remark',
            width: 40
          }
        ];
        Sheet1.getCell('A2').value = 'Os dados existem';
        Sheet1.getCell('B2').value = 'número do negócio';
        Sheet1.getCell('C2').value = 'Tipo de coleta';
        Sheet1.getCell('D2').value = 'Tipo de custo';
        Sheet1.getCell('E2').value = 'Valor a Pagar';
        Sheet1.getCell('F2').value = 'Hora da ocorrência (Formato: 2022-01-01 00:00:00)';
        Sheet1.getCell('G2').value = 'Método de compartilhamento igualitário';
        Sheet1.getCell('H2').value = 'Observações';
        Sheet1.mergeCells('A3:E3');
        Sheet1.getCell('A3').value = '1、每次仅导入 100000 条 /Importar apenas 100000 itens de cada vez\n' +
          '2、除了备注其他必填 /Tudo, exceto as notas, é obrigatório\n' +
          '3、不可更改此模板 /Esse modelo não pode ser alterado ';
        Sheet1.getRow(3).getCell(1).font = {
          color: { argb: 'ff0000' }
        };

        Sheet2.columns = [
          {
            header: that.$t('basicData.ExpenseType'), // 费用类型
            key: 'feeCode',
            width: 40
          }
        ];
        const Sheet2_data = [];
        that.feeTypeList.map(item => {
          Sheet2_data.push({
            feeCode: item.displayName + '-' + item.code,
            width: 20
          });
        });
        Sheet2.addRows(Sheet2_data);

        Sheet3.columns = [
          {
            header: that.$t('newOrder.CollectionType'), // 揽收类型',
            key: 'collectType',
            width: 40
          }
        ];
        const Sheet3_data = [
          { collectType: that.$t('collectionCenter.dropOff') + '-' + 1 },
          { collectType: that.$t('collectionCenter.doorPickUp') + '-' + 2 }
        ];
        Sheet3.addRows(Sheet3_data);

        // Sheet4 是否存在数据
        Sheet4.columns = [
          {
            header: that.$t('basicData.是否存在数据'),
            key: 'exitData',
            width: 40
          }
        ];
        const sheet4Types = [
          { name: that.$t('GlobalSetObj.yes'), code: 1 },
          { name: that.$t('GlobalSetObj.No'), code: 0 }
        ];
        const Sheet4_data = sheet4Types.map(item => {
          return {
            exitData: item.name + '-' + item.code,
            width: 20
          };
        });
        Sheet4.addRows(Sheet4_data);

        Sheet5.columns = [
          {
            header: that.$t('receivablePayable.FlatSharingMethod'), // 平摊方式,
            key: 'flatMethod',
            width: 40
          }
        ];
        const Sheet5_data = [
          { flatMethod: that.$t('receivablePayable.SpreadEquallyByWeight') + '-' + 1 },
          { flatMethod: that.$t('receivablePayable.SplitEquallyByTheNumberOfVotes') + '-' + 2 },
          { flatMethod: that.$t('receivablePayable.SpecifyTheAmount') + '-' + 3 }
        ];
        Sheet5.addRows(Sheet5_data);

        new Array(MAX_LENGTH).fill(0).forEach((_, idx) => {
          const row = idx + 4;

          // 是否存在数据
          Sheet1.getCell(row, 1).dataValidation = {
            type: 'list',
            formulae: [`=Sheet4!$A$2:$A${Sheet4_data.length + 1}`]
          };
          // 揽收类型
          Sheet1.getCell(row, 3).dataValidation = {
            type: 'list',
            formulae: [`=Sheet3!$A$2:$A${Sheet3_data.length + 1}`]
          };

          // 平摊方式
          Sheet1.getCell(row, 7).dataValidation = {
            type: 'list',
            formulae: [`=Sheet5!$A$2:$A${Sheet5_data.length + 1}`]
          };

          // 费用类型下拉框
          Sheet1.getCell(row, 4).dataValidation = {
            type: 'list',
            formulae: [`=Sheet2!$A$2:$A${Sheet2_data.length + 1}`]
          };

          Sheet1.getCell(row, 6).numFmt = '@';
        });
        const buffer = await wb.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
          type: 'application/octet-stream'
        });
        const saveName = that.setFileName();
        saveAs(blob, saveName);
      }

      try {
        await ddd();
      } catch (error) {
        console.error(error);
      }
    },

    // 下载模板（AJD/DSP/邮局/MDD）
    async downloadTemplate_two() {
      const that = this;
      async function ddd() {
        const wb = new ExcelJS.Workbook();
        const Sheet1 = wb.addWorksheet('Sheet1');
        const Sheet2 = wb.addWorksheet('Sheet2');
        const Sheet4 = wb.addWorksheet('Sheet4');
        const Sheet5 = wb.addWorksheet('Sheet5');
        Sheet1.columns = [
          {
            header: '是否存在数据',
            key: 'exitData',
            width: 40
          },
          {
            header: '业务单号',
            key: 'waybillNumber',
            width: 40
          },
          {
            header: '费用类型',
            key: 'feeCode',
            width: 40
          },
          {
            header: '应付金额',
            key: 'fee',
            width: 40
          },
          {
            header: '业务时间(格式：2022-01-01 00:00:00)',
            key: 'operateTime',
            width: 80
          },
          {
            header: '平摊方式',
            key: 'flatMethod',
            width: 40
          },
          {
            header: '备注',
            key: 'remark',
            width: 40
          }
        ];
        Sheet1.getCell('A2').value = 'Os dados existem';
        Sheet1.getCell('B2').value = 'número do negócio';
        Sheet1.getCell('C2').value = 'Tipo de custo';
        Sheet1.getCell('D2').value = 'Valor a Pagar';
        Sheet1.getCell('E2').value = 'Hora da ocorrência (Formato: 2022-01-01 00:00:00)';
        Sheet1.getCell('F2').value = 'Método de compartilhamento igualitário';
        Sheet1.getCell('G2').value = 'Observações';
        Sheet1.mergeCells('A3:E3');
        Sheet1.getCell('A3').value = '1、每次仅导入 100000 条 /Importar apenas 100000 itens de cada vez\n' +
          '2、除了备注其他必填 /Tudo, exceto as notas, é obrigatório\n' +
          '3、不可更改此模板 /Esse modelo não pode ser alterado ';
        Sheet1.getRow(3).getCell(1).font = {
          color: { argb: 'ff0000' }
        };

        Sheet2.columns = [
          {
            header: that.$t('basicData.ExpenseType'), // 费用类型
            key: 'feeCode',
            width: 40
          }
        ];
        const Sheet2_data = [];
        that.feeTypeList.map(item => {
          Sheet2_data.push({
            feeCode: item.displayName + '-' + item.code,
            width: 20
          });
        });
        Sheet2.addRows(Sheet2_data);

        // Sheet4 是否存在数据
        Sheet4.columns = [
          {
            header: that.$t('basicData.是否存在数据'),
            key: 'exitData',
            width: 40
          }
        ];
        const sheet4Types = [
          { name: that.$t('GlobalSetObj.yes'), code: 1 },
          { name: that.$t('GlobalSetObj.No'), code: 0 }
        ];
        const Sheet4_data = sheet4Types.map(item => {
          return {
            exitData: item.name + '-' + item.code,
            width: 20
          };
        });
        Sheet4.addRows(Sheet4_data);

        Sheet5.columns = [
          {
            header: that.$t('receivablePayable.FlatSharingMethod'), // 平摊方式,
            key: 'flatMethod',
            width: 40
          }
        ];
        const Sheet5_data = [
          { flatMethod: that.$t('receivablePayable.SpreadEquallyByWeight') + '-' + 0 },
          { flatMethod: that.$t('receivablePayable.SplitEquallyByTheNumberOfVotes') + '-' + 1 },
          { flatMethod: that.$t('receivablePayable.SpecifyTheAmount') + '-' + 2 }
        ];
        Sheet5.addRows(Sheet5_data);

        new Array(MAX_LENGTH).fill(0).forEach((_, idx) => {
          const row = idx + 4;

          // 是否存在数据
          Sheet1.getCell(row, 1).dataValidation = {
            type: 'list',
            formulae: [`=Sheet4!$A$2:$A${Sheet4_data.length + 1}`]
          };

          // 平摊方式
          Sheet1.getCell(row, 6).dataValidation = {
            type: 'list',
            formulae: [`=Sheet5!$A$2:$A${Sheet5_data.length + 1}`]
          };

          // 费用类型下拉框
          Sheet1.getCell(row, 3).dataValidation = {
            type: 'list',
            formulae: [`=Sheet2!$A$2:$A${Sheet2_data.length + 1}`]
          };

          Sheet1.getCell(row, 5).numFmt = '@';
        });
        const buffer = await wb.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
          type: 'application/octet-stream'
        });
        const saveName = that.setFileName();

        saveAs(blob, saveName);
      }

      try {
        await ddd();
      } catch (error) {
        console.error(error);
      }
    },

    // 下载模板（干支线）
    async downloadTemplate_three() {
      const that = this;
      async function ddd() {
        const wb = new ExcelJS.Workbook();
        const Sheet1 = wb.addWorksheet('Sheet1');
        const Sheet2 = wb.addWorksheet('Sheet2');
        const Sheet3 = wb.addWorksheet('Sheet3');
        Sheet1.columns = [
          {
            header: '是否存在数据',
            key: 'exitData',
            width: 40
          },
          {
            header: '运输单号',
            key: 'transportNumber',
            width: 40
          },
          {
            header: '费用类型',
            key: 'feeCode',
            width: 40
          },
          {
            header: '应付金额',
            key: 'fee',
            width: 40
          },
          {
            header: '业务时间(格式：2022-01-01 00:00:00)',
            key: 'operateTime',
            width: 80
          },
          {
            header: '备注',
            key: 'remark',
            width: 40
          }
        ];
        Sheet1.getCell('A2').value = 'Os dados existem';
        Sheet1.getCell('B2').value = 'Número do Pedido de Transporte';
        Sheet1.getCell('C2').value = 'Tipo de custo';
        Sheet1.getCell('D2').value = 'Valor a Pagar';
        Sheet1.getCell('E2').value = 'Hora da ocorrência (Formato: 2022-01-01 00:00:00)';
        Sheet1.getCell('F2').value = 'Observações';
        Sheet1.mergeCells('A3:F3');
        Sheet1.getCell('A3').value = '1、每次仅导入 100000 条 /Importar apenas 100000 itens de cada vez\n' +
        '2、除了备注其他必填 /Tudo, exceto as notas, é obrigatório\n' +
        '3、不可更改此模板 /Esse modelo não pode ser alterado ';
        Sheet1.getRow(3).height = 50;
        Sheet1.getRow(3).getCell(1).style = {
          font: {
            color: { argb: 'ff0000' }
          },
          alignment: {
            vertical: 'bottom', // 垂直居中
            horizontal: 'left', // 水平左对齐
            wrapText: true, // 自动换行
            indent: 0 // 禁止缩进
          }
        };

        Sheet2.columns = [
          {
            header: that.$t('basicData.ExpenseType'), // 费用类型
            key: 'feeCode',
            width: 40
          }
        ];
        const Sheet2_data = [];
        that.feeTypeList.map(item => {
          Sheet2_data.push({
            feeCode: item.displayName + '-' + item.code,
            width: 20
          });
        });
        Sheet2.addRows(Sheet2_data);

        // Sheet3 是否存在数据
        Sheet3.columns = [
          {
            header: that.$t('basicData.是否存在数据'),
            key: 'exitData',
            width: 40
          }
        ];
        const sheet3Types = [
          { name: that.$t('GlobalSetObj.yes'), code: 1 },
          { name: that.$t('GlobalSetObj.No'), code: 0 }
        ];
        const Sheet3_data = sheet3Types.map(item => {
          return {
            exitData: item.name + '-' + item.code,
            width: 20
          };
        });
        Sheet3.addRows(Sheet3_data);

        new Array(MAX_LENGTH).fill(0).forEach((_, idx) => {
          const row = idx + 4;

          // 是否存在数据
          Sheet1.getCell(row, 1).dataValidation = {
            type: 'list',
            formulae: [`=Sheet3!$A$2:$A${Sheet3_data.length + 1}`]
          };

          // 费用类型下拉框
          Sheet1.getCell(row, 3).dataValidation = {
            type: 'list',
            formulae: [`=Sheet2!$A$2:$A${Sheet2_data.length + 1}`]
          };

          Sheet1.getCell(row, 5).numFmt = '@';
        });
        const buffer = await wb.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
          type: 'application/octet-stream'
        });
        const saveName = that.setFileName();

        saveAs(blob, saveName);
      }

      try {
        await ddd();
      } catch (error) {
        console.error(error);
      }
    },

    // 设定模板名称
    setFileName() {
      const name = titleMap[this.payableType];
      console.log(name);
      return name + this.$t('receivablePayable.ImportAddCharges') + '.xlsx';
    },

    beforeUpload(file) {
      this.fileName = file.name;
      return true;
    },
    // 导入费用
    async importLogistics(importData) {
      const headObj = {
        '业务单号': 'waybillNumber',
        '运输单号': 'transportNumber',
        '应付金额': 'fee',
        '业务时间(格式：2022-01-01 00:00:00)': 'operateTime',
        '备注': 'remark'
      };
      const obj = {
        '是否存在数据': 'exitData',
        '揽收类型': 'collectType',
        '费用类型': 'feeCode',
        '平摊方式': 'flatMethod'
      };
      const excelData = importData[0].results.splice(2);
      // console.log(excelData);
      const dataList = [];
      excelData.map((item, index) => {
        const data = {};
        console.log(item, 'item');
        try {
          Object.keys(item).forEach((key, i) => {
            // console.log(key, i);
            // 需要映射的key
            if (obj[key]) {
              console.log(key, 1);
              data[obj[key]] = item[key]?.split('-').pop() || '';
            } else {
              console.log(key, 2);
              if (key === '业务时间(格式：2022-01-01 00:00:00)') {
                // const dateTimePattern = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/;
                // if (!dateTimePattern.test(item[key])) {
                if (!isValidDateTime(item[key])) {
                  const rowInfo = this.$t('basicData.row') + (index + 1) + this.$t('basicData.line');
                  const errorMsg = this.$t('receivablePayable.BusinessTimeFormatError');
                  throw new Error(`${rowInfo} ${errorMsg}: ${item[key]}`);
                }
                data[headObj[key]] = item[key];
              } else {
                data[headObj[key]] = item[key] || '';
              }
            }
          });
        } catch (error) {
          this.$message.error(error.message);
          // console.error(`Error processing row ${index + 1}:`, error.message);
          throw error;
        }
        console.log(data);
        dataList.push(data);
      });

      // console.log(dataList, 'dataList');
      if (!dataList.length) {
        this.$message({
          type: 'warning',
          message: this.$t('userManage.ImportDataIsEmpty')
        });
        return;
      }

      if (dataList.length > MAX_LENGTH) {
        this.$message({
          type: 'warning',
          message: this.$t('receivablePayable.Only100000PiecesImport')
        });
        return;
      }

      const list = dataList.map(item => {
        item.businessType = [1, 2].includes(this.payableType) ? 2 : 3;
        return item;
      });

      try {
        const API = this.payableType === 5 ? apiPayableTransportExpenseDownloadImportAddFee : apiPayableSiteExpenseImportAddFee;
        const params = this.payableType === 5 ? dataList : {
          list,
          payableType: this.payableType,
          fileName: this.fileName
        };
        const res = await API(params);
        if (res.code === 200) {
          await goFileUploadManagement(this);
          this.$emit('colse');
        } else {
          // 处理API调用失败的场景
          console.error('API调用失败:', res);
        }
      } catch (err) {
        console.error('导入费用时发生错误:', err);
      }
    }
  }
};
</script>

<style scoped>
.flex-c {
  display: flex;
  flex-wrap: wrap;
}
</style>
